<button type="button" mat-icon-button [mat-menu-trigger-for]="menu">
    <mat-icon *ngIf="!userImage">account_circle</mat-icon>
    <img *ngIf="userImage" #userPic src="{{currUser.imageUrl}}" class="user-image">
</button>

<mat-menu [overlapTrigger]="false"
          yPosition="below" #menu="matMenu">
    <ng-container *ngIf="currUser">
        <div class="flex-wrap userMenuChip">
            <mat-icon *ngIf="!userImage">account_circle</mat-icon>
            <img *ngIf="userImage" #userPic src="{{currUser.imageUrl}}" class="userMenuChip__img">
            <div>
                <a>
                    <span class="userMenuChip__user">{{currUser.getNombre()}}</span>
                    <span class="userMenuChip__otherInfo">{{currUser.eMail}}</span>
                </a>
            </div>
        </div>
        <ng-container *ngFor="let app of currUser.apps">
            <a *ngIf="!app.isExterno; else externo" [routerLink]="app.url" class="noDecoration">
                <button mat-menu-item>
                    {{app.nombre}}
                </button>
            </a>
            <ng-template #externo>
                <a [href]="app.url" target="_blank" class="noDecoration">
                    <button mat-menu-item>
                        {{app.nombre}}
                    </button>
                </a>
            </ng-template>
        </ng-container>
    </ng-container>
        <button mat-menu-item (click)="logout()">
            Cerrar sesión
        </button>
</mat-menu>
